import cn from 'classnames';

import { BACKGROUND_COLOR_CLASSNAMES, OPTION_WRAPPER } from './classnames';
import MenuItem from './MenuItem';
import { MenuBackgroundState, MenuProps } from './types';

function Menu<OptionValueType = string>({
  options,
  selected,
  onSelected,
  full,
  clampText,
  isDark,
  dark,
  isTransparency,
  transparencyMode,
  className = '',
  datatestid,
  'data-testid': dataTestId,
  htmlProps,
  ...menuProps
}: MenuProps<OptionValueType>) {
  let backgroundState: MenuBackgroundState = isDark || dark ? 'dark' : 'light';

  if (isTransparency || transparencyMode) {
    backgroundState = 'transparency';
  }

  return (
    <div
      className={cn(
        OPTION_WRAPPER,
        isDark || dark ? 'crehui-scrollable-dark ' : 'crehui-scrollable',
        full ? 'w-full' : 'sm:min-w-280',
        BACKGROUND_COLOR_CLASSNAMES[backgroundState],
        className,
      )}
      data-testid={dataTestId || datatestid}
      {...menuProps}
      {...htmlProps}
    >
      {options.map(opt => {
        const onSelect = () => {
          if (onSelected) {
            onSelected(opt);
          }
        };

        return (
          <MenuItem
            key={`option-menu-${opt.label}-${opt.value}`}
            onClick={onSelect}
            selected={selected && selected.value === opt.value}
            jsxLabel={opt.jsxLabel}
            label={opt.label}
            clampText={clampText}
            isDark={isDark || dark}
            isTransparency={isTransparency || transparencyMode}
            data-testid={
              // @ts-ignore
              opt['data-testid'] || `${dataTestId || datatestid}-${opt.label}`
            }
          />
        );
      })}
    </div>
  );
}

export default Menu;
